/* eslint-disable no-unused-vars */

import React, { useEffect, useMemo, useState } from 'react';
import { Box, Flex } from 'theme-ui';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import useWindowSize from '~/hooks/components/use-window-size';

const NUM_IMAGES = 16;

const InstagramFeed = React.memo(function InstagramFeed({ media }) {
  const { images } = media;
  const [imgArr, setImgArr] = useState([]);
  const { width } = useWindowSize();

  const getImageArray = (imageArray) => {
    const { length } = imageArray;
    const newArr = imageArray;
    if (length >= NUM_IMAGES) return imageArray;
    const remaining = NUM_IMAGES - length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < remaining; i++) {
      newArr.push(imageArray[i % length]);
    }
    return newArr;
  };

  function QuickImg({ image }) {
    return <GatsbyImage sx={{ height: '100%', width: '100%' }} alt={image.title} image={getImage(image)} />;
  }

  // memo the array operations to reduce computation on resize
  const desktopSectionArray = useMemo(() => {
    return [imgArr.slice(0, NUM_IMAGES / 2), imgArr.slice(NUM_IMAGES / 2)];
  }, [imgArr, NUM_IMAGES]);

  const mobileSectionArray = useMemo(() => {
    return [imgArr.slice(0, 6), imgArr.slice(6, 11), imgArr.slice(11, NUM_IMAGES + 1)];
  }, [imgArr, NUM_IMAGES]);

  const desktopSection1 = useMemo(
    () =>
      desktopSectionArray?.[0]?.map((img) => (
        <Box key={img.id} sx={{ minWidth: '322px', minHeight: '322px', mr: '2.4rem' }}>
          <QuickImg image={img} />
        </Box>
      )),
    [desktopSectionArray]
  );

  const desktopSection2 = useMemo(
    () =>
      desktopSectionArray?.[1]?.map((img) => (
        <Box key={img.id} sx={{ minWidth: '322px', minHeight: '322px', mr: '2.4rem' }}>
          <QuickImg image={img} />
        </Box>
      )),
    [desktopSectionArray]
  );

  const mobileSection1 = useMemo(
    () =>
      mobileSectionArray?.[0]?.map((img) => (
        <Box
          key={img.id}
          sx={{ minWidth: ['240px', '445px'], minHeight: ['240px', '445px'], mr: ['1.2rem', '2.2rem'] }}
        >
          <QuickImg image={img} />
        </Box>
      )),
    [mobileSectionArray]
  );

  const mobileSection2 = useMemo(
    () =>
      mobileSectionArray?.[1]?.map((img) => (
        <Box
          key={img.id}
          sx={{ minWidth: ['240px', '445px'], minHeight: ['240px', '445px'], mr: ['1.2rem', '2.2rem'] }}
        >
          <QuickImg image={img} />
        </Box>
      )),
    [mobileSectionArray]
  );
  const mobileSection3 = useMemo(
    () =>
      mobileSectionArray?.[2]?.map((img) => (
        <Box
          key={img.id}
          sx={{ minWidth: ['240px', '445px'], minHeight: ['240px', '445px'], mr: ['1.2rem', '2.2rem'] }}
        >
          <QuickImg image={img} />
        </Box>
      )),
    [mobileSectionArray]
  );

  useEffect(() => {
    setImgArr(getImageArray(images));
  }, []);
  return (
    <Flex
      sx={{
        position: 'relative',
        width: '100%',
        flexWrap: 'wrap',
        overflow: 'hidden',
        margin: '0 auto',
      }}
    >
      {width > 1024 ? (
        <>
          <Flex sx={{ position: 'relative', minWidth: '125vw', right: '200px' }}>{desktopSection1}</Flex>

          <Flex
            sx={{
              position: 'relative',
              minWidth: '125vw',
              right: '100px',
              mt: '2.4rem',
            }}
          >
            {desktopSection2}
          </Flex>
        </>
      ) : (
        <>
          <Flex sx={{ position: 'relative', minWidth: '125vw', right: ['170px', '300px'] }}>{mobileSection1}</Flex>
          <Flex
            sx={{
              position: 'relative',
              minWidth: '125vw',
              right: '50px',
              mt: ['1.2rem', '2.2rem'],
            }}
          >
            {mobileSection2}
          </Flex>
          <Flex
            sx={{
              position: 'relative',
              minWidth: '125vw',
              right: '100px',
              mt: ['1.2rem', '2.2rem'],
            }}
          >
            {mobileSection3}
          </Flex>
        </>
      )}
    </Flex>
  );
});

export default InstagramFeed;
